/* Print functionality for the homes listing */
import printJS from 'print-js';

export function archive_homes() {
	
	( ( $ ) => {

		if ( $( 'body.page-homes-cottages-for-sale' ).length <= 0 ) {
			return;
		}

		$( '.btn-print' ).on( 'click', ( ev ) => {
			const button = $( ev.currentTarget );

			let url = window.location.href;

			button.prop( 'disabled', true );

			if ( url.indexOf( '?' ) > 0 ) {
				url = `${url}&print=1`;
			} else {
				url = `${url}?print=1`;
			}
		
			// Your AJAX request with loader
			$.ajax({
				type: "POST",
				url: '/wp-json/pri-rest-extender/v1/convert-pdf/list',
				data: { 'url': url },
				dataType: 'json',
				beforeSend: function() {
					$('#ajax-loader').show();
				},
				success: function(response) {
					printJS({ printable: response.file_url, type: 'pdf', showModal: false });
				},
				complete: function() {
					$('#ajax-loader').hide();
					button.prop('disabled', false);
				}
			});

			ev.preventDefault();
		} );


		// Map show/hide
		if ( $( '.results-view-mode' ).length > 0 ) {

			const apply_view_mode = ( ev ) => {
				const view_active = $( '.results-view-mode' ).find( 'input[type="radio"]:checked' );

				if ( 'results-view-mode--map' == view_active.prop( 'id' ) ) {
					$( '#homes-results--column-cards' )
						.removeClass( 'col-lg' )
						.addClass( 'col-lg-6' );

					$( '#homes-results--column-cards' ).find( '.facetwp-template > .col-lg-3' ).each( ( ind, ele ) => {
						$( ele )
							.removeClass( 'col-lg-3' )
							.addClass( 'col-lg-6' );
					} );

					$( '#homes-results--column-map' ).removeClass( 'd-none' );

				} else if ( 'results-view-mode--list' == view_active.prop( 'id' ) ) {
					$( '#homes-results--column-cards' )
						.removeClass( 'col-lg-6' )
						.addClass( 'col-lg' );

					$( '#homes-results--column-cards' ).find( '.facetwp-template > .col-lg-6' ).each( ( ind, ele ) => {
						$( ele )
							.removeClass( 'col-lg-6' )
							.addClass( 'col-lg-3' );
					} );

					$( '#homes-results--column-map' ).addClass( 'd-none' );
				}
			}

			$( '.results-view-mode input[type="radio"]' ).on( 'click', apply_view_mode );

			$( document ).on( 'facetwp-loaded', apply_view_mode );
		}

		// Store and read the filters in cookies
		if ( 'homes-cottages-for-sale' == FWP_HTTP.uri ) {

			// After FacetWP reloads, store any updates into a cookie
			$( document ).on( 'facetwp-loaded', ( ev ) => {
				var date = new Date();
				var facets = window.location.search;
				date.setTime( date.getTime() + ( 24 * 60 * 60 * 1000 ) );
				document.cookie = "facetdata_homes=" + facets + "; expires=" + date.toGMTString() + "; path=/";
			} );

			// When FacetWP first initializes, look for the "facetdata_homes" cookie
			// If it exists, set window.location.search= facetdata_homes
			$( document ).on( 'facetwp-refresh', ( ev ) => {
				if ( ! FWP.loaded ) {
					var facets = window.location.search;
					var facetdata_homes = readCookie( 'facetdata_homes' );
					if ( null != facetdata_homes && '' == facets && '' != facetdata_homes && facets != facetdata_homes ) {
						document.cookie = 'facetdata_homes=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
						window.location.search = facetdata_homes;
					}
				}
			} );

			// Cookie handler
			const readCookie = ( name ) => {
				var nameEQ = name + '=';
				var ca = document.cookie.split( ';' );
				for ( var i = 0; i < ca.length; i++ ) {
					var c = ca[i];
					while ( c.charAt(0) == ' ' ) c = c.substring( 1, c.length );
					if ( c.indexOf( nameEQ ) == 0 ) return c.substring( nameEQ.length, c.length );
				}
				return null;
			}
		}
		

	} )( window.jQuery );
}